import KeywordManagement from './keywordManagement'
export default KeywordManagement
